// extracted by mini-css-extract-plugin
module.exports = {"bottomSash":"ProductBottomSash_bottomSash__1FVg_","spinAround":"ProductBottomSash_spinAround__34gHs"};